define('modules/lp_integration/views/mdirector_fields_step_itemview',['require','exports','module','base/itemview','ldsh!../templates/mdirector_fields_step'],function(require, exports, module){
  "use strict";

  var ItemView = require("base/itemview");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/mdirector_fields_step"),
    className: "ed-section-group",
    helpers: function() {
      return {
        dataFields: this.parent.model.get("fields")
      };
    }
  });
});

